"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFindingDirectSuggestionsOutputDtoSchema = exports.findingDirectSuggestionDtoSchema = exports.getFindingDirectSuggestionsInputDtoSchema = exports.listFindingFacetOptionsOutputDtoSchema = exports.findingFacetOptionDtoSchema = exports.listFindingFacetOptionsInputDtoSchema = exports.getFindingFilterMetaOutputDtoSchema = exports.getFindingFilterMetaInputDtoSchema = exports.getBuildsExhibitingOutputDtoSchema = exports.getBuildsExhibitingInputDtoSchema = exports.getFindingSummaryOutputDtoSchema = exports.getFindingSummaryInputDtoSchema = exports.getFindingOutputDtoSchema = exports.projectionFieldProvenanceSchema = exports.projectionFieldContributorSchema = exports.deleteFindingOutputDtoSchema = exports.deleteFindingInputDtoSchema = exports.unlinkAssertionResultsFromFindingOutputDtoSchema = exports.unlinkAssertionResultsFromFindingInputDtoSchema = exports.linkAssertionResultsToFindingOutputDtoSchema = exports.linkAssertionResultsToFindingInputDtoSchema = exports.createFindingOutputDtoSchema = exports.createFindingInputDtoSchema = exports.getFindingByNumberInputDtoSchema = exports.getFindingInputDtoSchema = exports.listFindingsOutputDtoSchema = exports.listFindingsInputDtoSchema = exports.findingRowDtoSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const list_build_design_objects_dto_js_1 = require("./list-build-design-objects.dto.js");
const enum_names_js_1 = require("./enum-names.js");
const log_entry_row_dto_js_1 = require("./log-entry-row.dto.js");
const query_builder_helpers_js_1 = require("./query-builder-helpers.js");
const severitySchema = sigma_engine_shared_1.RequirementsV2.RequirementSeveritySchema;
const workflowStateSchema = sigma_engine_shared_1.RequirementsV2.RequirementWorkflowStateSchema;
const severityNameSchema = enum_names_js_1.requirementSeverityNameSchema.describe('Name of the numeric `severity`, e.g. `Warning`.');
const workflowStateNameSchema = enum_names_js_1.requirementWorkflowStateNameSchema.describe('Name of the numeric `workflowState`, e.g. `Unreviewed`.');
exports.findingRowDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    findingNumber: zod_1.z
        .number()
        .int()
        .positive()
        .describe('Per-owner monotonic sequence value. Rendered as `FINDING-${findingNumber}`.'),
    projectId: zod_1.z.string(),
    ownerId: zod_1.z.string(),
    severity: severitySchema,
    severityName: severityNameSchema,
    workflowState: workflowStateSchema,
    workflowStateName: workflowStateNameSchema,
    message: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    latestLogEntryId: zod_1.z.string().nullable(),
    latestLogEntryAt: zod_1.z.date().nullable(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
const findingBuildScopeSchema = zod_1.z
    .string()
    .optional()
    .describe('Revision (build) to scope to. Only findings exhibiting in this build (via a linked log entry or a linked assertion result) are included. Omit for the project-wide view across every revision.');
exports.listFindingsInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: findingBuildScopeSchema,
    limit: zod_1.z.number().min(1).max(500).optional(),
    cursor: zod_1.z.string().optional(),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.findingFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(cadstrom_shared_1.RequirementsV2.findingFilterSchema).optional(),
});
exports.listFindingsOutputDtoSchema = zod_1.z.object({
    items: exports.findingRowDtoSchema.array(),
    hasNextPage: zod_1.z.boolean(),
    nextCursor: zod_1.z.string().nullable(),
});
exports.getFindingInputDtoSchema = zod_1.z.object({ findingId: zod_1.z.string() });
exports.getFindingByNumberInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string().describe('Project tenancy. Must match the page context the URL belongs to.'),
    findingNumber: zod_1.z.number().int().positive().describe('Per-owner sequence value parsed from a `FINDING-N` slug.'),
});
exports.createFindingInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: zod_1.z
        .string()
        .describe('Build that anchors the seed log entry. Findings span builds; pick the build the user is viewing when they create the finding.'),
    severity: severitySchema.describe(`Severity the author assigns to the finding. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.RequirementSeverity)}`),
    workflowState: workflowStateSchema
        .optional()
        .describe(`Initial workflow state. Defaults to \`unreviewed\` when omitted. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.RequirementWorkflowState)}`),
    message: zod_1.z.string().optional().describe('Short user-facing message.'),
    description: zod_1.z.string().optional().describe('Long-form description; renders alongside `message`.'),
    linkedAssertionResultIds: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .describe('Assertion-result ids to link to the new finding. The service writes one seed log entry linked to the finding and every supplied assertion result.'),
});
exports.createFindingOutputDtoSchema = zod_1.z.object({
    finding: exports.findingRowDtoSchema,
});
exports.linkAssertionResultsToFindingInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string().describe('Build currently in view. Every linked assertion result must belong to this build.'),
    findingId: zod_1.z.string(),
    linkedAssertionResultIds: zod_1.z
        .array(zod_1.z.string())
        .min(1)
        .describe('Assertion-result ids to directly link to the existing finding.'),
});
exports.linkAssertionResultsToFindingOutputDtoSchema = zod_1.z.object({
    finding: exports.findingRowDtoSchema,
    linkedAssertionResultIds: zod_1.z.string().array(),
});
exports.unlinkAssertionResultsFromFindingInputDtoSchema = zod_1.z.object({
    findingId: zod_1.z.string(),
    assertionResultIds: zod_1.z.array(zod_1.z.string()).min(1),
});
exports.unlinkAssertionResultsFromFindingOutputDtoSchema = zod_1.z.object({
    finding: exports.findingRowDtoSchema,
    unlinkedAssertionResultIds: zod_1.z.string().array(),
});
exports.deleteFindingInputDtoSchema = zod_1.z.object({
    findingId: zod_1.z.string(),
});
exports.deleteFindingOutputDtoSchema = zod_1.z.object({
    deleted: zod_1.z.boolean(),
});
const linkedAssertionResultRowSchema = zod_1.z.object({
    id: zod_1.z.string(),
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string(),
    requirementDefinitionId: zod_1.z.string(),
    assertionDefinitionId: zod_1.z.string(),
    resultSlug: zod_1.z.string(),
    severity: severitySchema,
    severityName: severityNameSchema,
    workflowState: workflowStateSchema,
    workflowStateName: workflowStateNameSchema,
    message: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    latestLogEntryId: zod_1.z.string().nullable(),
    latestLogEntryAt: zod_1.z.date().nullable(),
    continuityKeyType: sigma_engine_shared_1.RequirementsV2.ContinuityKeyTypeSchema.nullable(),
    continuityKey: zod_1.z.string().nullable(),
    legacyAnalysisRequirementResultId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.projectionFieldContributorSchema = zod_1.z.object({
    logEntryId: zod_1.z.string(),
    authorRole: sigma_engine_shared_1.RequirementsV2.LogEntryAuthorRoleSchema,
    authorUserId: zod_1.z.string().nullable(),
});
exports.projectionFieldProvenanceSchema = zod_1.z
    .object({
    severity: exports.projectionFieldContributorSchema.nullable(),
    workflowState: exports.projectionFieldContributorSchema.nullable(),
    message: exports.projectionFieldContributorSchema.nullable(),
    description: exports.projectionFieldContributorSchema.nullable(),
})
    .describe("Which log entry currently supplies each of the finding's projected fields. Fields resolve independently, so each may name a different entry and author. `null` means no entry contributes that field. Clients use this to warn before an override displaces another author's value.");
exports.getFindingOutputDtoSchema = zod_1.z.object({
    finding: exports.findingRowDtoSchema,
    linkedAssertionResultIds: zod_1.z.string().array(),
    linkedAssertionResults: linkedAssertionResultRowSchema.array(),
    history: log_entry_row_dto_js_1.logEntryRowSchema.array(),
    designObjects: list_build_design_objects_dto_js_1.buildDesignObjectSchema.array(),
    fieldProvenance: exports.projectionFieldProvenanceSchema,
});
exports.getFindingSummaryInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: findingBuildScopeSchema,
});
exports.getFindingSummaryOutputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    totalCount: zod_1.z.number(),
    bySeverity: zod_1.z.partialRecord(zod_1.z.coerce.number().pipe(severitySchema), zod_1.z.number()),
    byWorkflowState: zod_1.z.partialRecord(zod_1.z.coerce.number().pipe(workflowStateSchema), zod_1.z.number()),
    bySeverityName: zod_1.z.partialRecord(enum_names_js_1.requirementSeverityNameSchema, zod_1.z.number()),
    byWorkflowStateName: zod_1.z.partialRecord(enum_names_js_1.requirementWorkflowStateNameSchema, zod_1.z.number()),
});
exports.getBuildsExhibitingInputDtoSchema = zod_1.z.object({ findingId: zod_1.z.string() });
exports.getBuildsExhibitingOutputDtoSchema = zod_1.z.object({
    builds: zod_1.z.object({ id: zod_1.z.string(), displayName: zod_1.z.string().nullable() }).array(),
});
const findingFacetIdSchema = zod_1.z.enum(['findingNumber', 'severity', 'workflowState', 'message', 'designObject']);
exports.getFindingFilterMetaInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: findingBuildScopeSchema,
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.findingFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
});
exports.getFindingFilterMetaOutputDtoSchema = zod_1.z.object({
    totalCount: zod_1.z.number(),
    filteredCount: zod_1.z.number(),
});
exports.listFindingFacetOptionsInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: findingBuildScopeSchema,
    facetId: findingFacetIdSchema,
    valueSearch: zod_1.z.string().trim().max(200).optional(),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.findingFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
});
exports.findingFacetOptionDtoSchema = zod_1.z.object({
    value: zod_1.z.string(),
    label: zod_1.z.string(),
    count: zod_1.z.number(),
    group: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
});
exports.listFindingFacetOptionsOutputDtoSchema = zod_1.z.object({
    options: exports.findingFacetOptionDtoSchema.array(),
});
exports.getFindingDirectSuggestionsInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z.string(),
    buildId: findingBuildScopeSchema,
    query: zod_1.z.string().trim().min(1).max(200),
    searchQuery: zod_1.z.string().trim().max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.findingFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
});
exports.findingDirectSuggestionDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    facetId: findingFacetIdSchema,
    facetLabel: zod_1.z.string(),
    operator: zod_1.z.literal('is'),
    value: zod_1.z.string(),
    label: zod_1.z.string(),
    count: zod_1.z.number(),
    description: zod_1.z.string().optional(),
});
exports.getFindingDirectSuggestionsOutputDtoSchema = zod_1.z.object({
    suggestions: exports.findingDirectSuggestionDtoSchema.array(),
});
//# sourceMappingURL=findings.dto.js.map